export default {
      id: "pattern-plus-right-usage",
      viewBox: "0 0 157 158",
      url: "../icon/" + "icons.svg#pattern-plus-right-usage",
      toString: function () {
        return this.url;
      }
    }